import { reviewsService } from '@services';
import { reviewsConstants } from '@constants/reviews';

export const reviewActions = {
    getAll,
    loadMore,
    request,
    resetLoading,
    resetNewExist,
    updateReviews,
    updateReview,
    setListingVerification,
    checkNewExistSuccess,
    invalidateReviews,
};

function getAll(params, pageToken = null, pageSize = 25) {
    return dispatch => {
        dispatch(request());
        reviewsService.getAll(params, pageToken, pageSize).then(
            reviews => dispatch(successAll(reviews)),
            () => {},
        );
    };
}

function loadMore(params, pageToken = null, pageSize = 25) {
    return dispatch => {
        reviewsService.getAll(params, pageToken, pageSize).then(
            reviews => dispatch(successLoadMore(reviews)),
            () => {},
        );
    };
}

function invalidateReviews(params, pageToken = null, pageSize = 25) {
    return dispatch => {
        reviewsService.getAll(params, pageToken, pageSize).then(
            reviews => dispatch(successAll(reviews)),
            () => {},
        );
    };
}

function request() {
    return { type: reviewsConstants.REVIEWS_REQUEST };
}

function successAll(payload) {
    return { type: reviewsConstants.REVIEWS_SUCCESS, payload };
}

function successLoadMore(payload) {
    return { type: reviewsConstants.REVIEWS_LOAD_MORE_SUCCESS, payload };
}

function resetLoading() {
    return { type: reviewsConstants.RESET_LOADING };
}

function checkNewExistSuccess(data) {
    return { type: reviewsConstants.NEW_REVIEW_EXIST_SUCCESS, payload: data };
}

function resetNewExist() {
    return { type: reviewsConstants.NEW_REVIEW_EXIST_RESET };
}

function updateReviews(reviews) {
    return { type: reviewsConstants.UPDATE_REVIEWS, payload: reviews };
}

function updateReview(review) {
    return { type: reviewsConstants.UPDATE_REVIEW, payload: review };
}

function setListingVerification({ locationId, integrationName }, isVerified) {
    return (dispatch, getState) => {
        const current = getState().reviews.reviews || [];
        const patched = current.map(item =>
            item.locationId === locationId && item.integrationName === integrationName
                ? { ...item, isProfileVerified: isVerified }
                : item,
        );
        dispatch(updateReviews(patched));
    };
}
